import type { ClipboardEvent, DragEvent } from 'react';

const refuse = (event: ClipboardEvent<HTMLInputElement> | DragEvent<HTMLInputElement>) => {
  event.preventDefault();
};

/**
 * Handlers that make a confirmation password something the user has to type.
 *
 * Spread on the Confirm New Password / Re-enter New Password input only. Copy, cut and paste are refused --
 * from the keyboard and the context menu alike, since both raise the same events -- and so are dragging a value
 * out and dropping one in, which would be paste by another route. A confirmation pasted from the field above it
 * confirms nothing. Typing, the show/hide toggle and validation are untouched, and no other field is affected.
 */
export const preventCopyProps = {
  onCopy: refuse,
  onCut: refuse,
  onPaste: refuse,
  onDragStart: refuse,
  onDrop: refuse,
} as const;
